<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'
import { useStore } from '@composables/use-store'

const store = useStore()

const mixes = ref([])

const recentlyPlayedMixes = computed(
    () =>
        store.state.playback &&
        store.state.playback.history &&
        store.state.playback.history
            .reduce((unique, item) => (unique.includes(item) ? unique : [...unique, item]), [])
            .slice(0, 6)
)

function getMixes() {
    const promises =
        recentlyPlayedMixes.value &&
        recentlyPlayedMixes.value.length &&
        recentlyPlayedMixes.value.map(id => DataLayer.mixes.getById(id))
    promises &&
        promises.length &&
        Promise.all(promises).then(values => {
            mixes.value = values.map(res => res.body)
        })
}

watch(recentlyPlayedMixes, getMixes)

onMounted(getMixes)
</script>

<template>
    <div v-if="mixes && mixes.length">
        <BaseSection
            :show-all-link="{ name: 'browse/mixes/recently' }"
            title="Recently Played"
            show-all-title="Browse More"
        >
            <MixGridBlock :mixes="mixes" />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
